import React from 'react';
import styled from 'styled-components';
import { ButtonPrimary } from '@spotify-internal/encore-web';

import {
  COLOR_BLACK,
  COLOR_SPOTIFY_GREEN,
} from 'client/components/MarketingPagesShared/styles';
import { MarketingImage } from 'client/components/MarketingPagesShared/MarketingImage';
import { MarketingVideo } from 'client/components/MarketingPagesShared/MarketingVideo';
import { MD_SCREEN_MIN } from 'modules/Styleguide';
import { useT } from 'client/i18n/hooks/useT';
import { INTEGRATION_CONNECTION_MENU_MODE } from '../constants';

// TODO https://anchorfm.atlassian.net/browse/CAST-2756: Update final video assets
const VIDEO_DATA = {
  height: 546,
  width: 970,
  imagePath: 'span/ads-by-anchor-video-thumbnail',
  videoId: 'YZ_oYxqWL9g',
};

const VideoSection = styled.section`
  width: 100%;
  max-width: 880px;
  margin: 0 auto;
  padding: 150px 24px;
`;

const VideoTitle = styled.h2`
  font-size: 3.125rem;
  line-height: 40px;
  text-align: center;
  color: ${COLOR_BLACK};
  margin-bottom: 60px;
`;

const VideoWrapper = styled.div`
  width: 100%;
  max-width: 1064px;
  margin: 0 auto 58px;
  background: #24203f;
  @media (max-width: ${MD_SCREEN_MIN}px) {
    width: 100%;
  }
`;

const ButtonWrapper = styled.div`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;

  button {
    div[class*='ButtonInner'] {
      background: ${COLOR_SPOTIFY_GREEN};
      color: ${COLOR_BLACK};
    }
  }

  button:hover {
    div[class*='ButtonInner'] {
      background: ${COLOR_SPOTIFY_GREEN};
      color: ${COLOR_BLACK};
    }
  }
`;

export function Video({
  onClick,
  currentStatus,
}: {
  onClick: () => void;
  currentStatus: INTEGRATION_CONNECTION_MENU_MODE;
}) {
  const t = useT();
  const isSignup = currentStatus === 'create';

  return (
    <VideoSection>
      <VideoTitle>
        {t(
          'IntegrationConnectionScreen.Video.Title',
          'Upload to Anchor, watch on Spotify',
          'The title on the video section of the Integration Connection Screen'
        )}
      </VideoTitle>
      <VideoWrapper>
        {/* TODO https://anchorfm.atlassian.net/browse/CAST-2756: Update final video and image asset */}
        <MarketingVideo
          height={VIDEO_DATA.height}
          title={t(
            'AdsByAnchorScreen.Video.VideoTitle',
            'Introducing Ads by Anchor',
            'Ads by Anchor page video title'
          )}
          width={VIDEO_DATA.width}
          youTubeVideoId={VIDEO_DATA.videoId}
        >
          <MarketingImage
            alt={t(
              'AdsByAnchorScreen.Video.VideoDescription',
              'Group of illustrated people recording a podcast',
              'Ads by Anchor page video description'
            )}
            height={VIDEO_DATA.height}
            imagePath={VIDEO_DATA.imagePath}
            width={VIDEO_DATA.width}
          />
        </MarketingVideo>
      </VideoWrapper>
      <ButtonWrapper>
        <ButtonPrimary fullWidth colorSet="brightAccent" onClick={onClick}>
          {isSignup
            ? t('Button.Signup', 'Sign up', 'Sign up button text')
            : t('Button.Login', 'Log in', 'Log in button text')}
        </ButtonPrimary>
      </ButtonWrapper>
    </VideoSection>
  );
}
